import { isMobileDevice } from '@/utils/util'
import { hasClass } from '@/utils/Player/utils'
import { useStore } from '@gx-vuex'

export default function useImage() {
  const store = useStore()
  const imageLoadedLen = ref(0)

  const imageLoaded = ref(false)

  const ImageFun = (url, success, error) => {
    const img = new Image()
    img.onload = function () {
      if (img.complete == true) {
        success()
      }
    }
    img.onerror = function () {
      error()
    }
    img.src = url
  }

  watch(
    () => imageLoadedLen.value,
    (val) => {
      if (val === document.querySelectorAll('.content img').length && val > 0) {
        imageLoaded.value = true
      }
    },
    { deep: true }
  )

  const initImage = () => {
    let imageArrary: any[] = []
    const list = document.querySelectorAll('#newContent img')
    const previewElList = document.querySelectorAll('#newContent .image-player')

    list.forEach((item) => {
      if (item.classList.contains('image-player')) {
        let src = item.getAttribute('data-src') || ''
        src = src.split('?')?.[0] || ''
        const originRecord = store.global.details?.photoList
          ? store.global.details?.photoList?.find((el) => el.picPath === src)
          : {}
        const params = {
          pic: src,
          width: originRecord
            ? originRecord.width
            : item.getBoundingClientRect()
            ? item.getBoundingClientRect().width || 0
            : 0,
          height: originRecord
            ? originRecord.height
            : item.getBoundingClientRect()
            ? item.getBoundingClientRect().height || 0
            : 0
        }

        imageArrary.push(params)
      }
    })

    store.global.articleImageShow.imageList = imageArrary.map((item) => item.pic)

    for (let i = 0; i < list.length; i++) {
      const hasPreview = list[i].classList.contains('image-player')
      const record: any = list[i]
      const src = record.getAttribute('src')
      // 防止重复加载
      if (record.loading === true) {
        continue
      }
      //没有该属性代表不加载
      if (!src) {
        continue
      }
      record.loading = true
      ImageFun(
        src,
        () => {
          imageLoadedLen.value += 1

          if (hasPreview) {
            record.parentNode.classList.remove('loading')
            record.classList.add('preview-image-loaded')
            record.classList.remove('none')
            record.parentNode.querySelector('.preview-image-placehold') &&
              record.parentNode.querySelector('.preview-image-placehold').classList.add('none')
            record.parentNode.querySelector('.preview-image-error') &&
              record.parentNode.querySelector('.preview-image-error').classList.add('none')
          }
        },
        () => {
          imageLoadedLen.value += 1

          if (hasPreview) {
            record.classList.add('none')
            record.parentNode.querySelector('.preview-image-placehold') &&
              record.parentNode.querySelector('.preview-image-placehold').classList.add('none')
            record.parentNode.querySelector('.preview-image-error') &&
              record.parentNode.querySelector('.preview-image-error').classList.remove('none')
            imageLoadedLen.value += 1
          }
        }
      )
    }

    for (let i = 0; i < previewElList.length; i++) {
      previewElList[i].addEventListener('click', () => {
        // @ts-ignore
        if (hasClass(previewElList[i], 'preview-image-loaded')) {
          try {
            imageArrary = imageArrary.map((el) => {
              if (!el.width) {
                el.width = previewElList[i].getBoundingClientRect().width
              }
              if (!el.height) {
                el.height = previewElList[i].getBoundingClientRect().height
              }
              return el
            })

            let dataInfo = null
            try {
              dataInfo = previewElList[i].parentNode.parentNode.getAttribute('data-rmrbnative')
              if (dataInfo) {
                dataInfo = Base64().decode(dataInfo)
                dataInfo = JSON.parse(dataInfo)
              }
            } catch (error) {}

            if (!dataInfo || (dataInfo && dataInfo.linkType == 1)) {
              if (isMobileDevice()) {
                nextTick(() => {
                  store.global.articleImageShow.active = i
                  store.global.articleImageShow.open = true
                })
              }
            }
          } catch (e) {}
        }
      })
    }
  }

  const remove = () => {
    const list = document.querySelectorAll('.content img')
    for (let i = 0; i < list.length; i++) {
      const hasPreview = list[i].classList.contains('image-player')
      if (hasPreview) {
        list[i].removeEventListener('click', () => {})
      }
    }
    imageLoadedLen.value = 0
    imageLoaded.value = false
  }

  return {
    remove,
    initImage,
    imageLoaded
  }
}
